import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import AppURL from '../api/AppURL';

const Register = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    password: ''
  });

  const [message, setMessage] = useState('');
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrors({});
    setMessage('');

    axios.post(AppURL.UserRegister, form)
      .then(res => {
        setMessage('✅ User registered successfully!');
        setTimeout(() => navigate('/login'), 2000);
      })
      .catch(err => {
        if (err.response && err.response.data && err.response.data.errors) {
          setErrors(err.response.data.errors);
        } else {
          setMessage('❌ Registration failed.');
        }
      });
  };

  return (
    <div className="container mt-5 pt-5">
      <h4>Create New Account</h4>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Full Name"
          className="form-control mb-2"
          value={form.name}
          onChange={handleChange}
        />
        {errors.name && <div className="text-danger mb-2">{errors.name[0]}</div>}

        <input
          type="email"
          name="email"
          placeholder="Email"
          className="form-control mb-2"
          value={form.email}
          onChange={handleChange}
        />
        {errors.email && <div className="text-danger mb-2">{errors.email[0]}</div>}

        <input
          type="password"
          name="password"
          placeholder="Password"
          className="form-control mb-2"
          value={form.password}
          onChange={handleChange}
        />
        {errors.password && <div className="text-danger mb-2">{errors.password[0]}</div>}

        <button type="submit" className="btn btn-success">Register</button>

        <div className="mt-3">
          Already have an account? <Link to="/login">Login here</Link>
        </div>

        {message && <div className="mt-3">{message}</div>}
      </form>
    </div>
  );
};

export default Register;
